/**
*
* RedAgendaPresentation
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';

import setLanguageContent from 'helpers/setLanguageContent';
import Wrapper from 'components/Templates/dynamics/Wrapper';
import RedSpeakersSpeaker from 'components/Templates/components/speakers/RedSpeakers/RedSpeakersSpeaker';

import selectSpeakerById from 'helpers/selectSpeakerById';


class RedAgendaPresentation extends React.Component {

  constructor() {
    super();

    this.state = {
      prevPresentationDisabled: false,
      nextPresentationDisabled: false,
    }

    this.handleClick = this.handleClick.bind(this);
    this.handlePresentationToggle = this.handlePresentationToggle.bind(this);
    this.handlePrevPresentation = this.handlePrevPresentation.bind(this);
    this.handleNextPresentation = this.handleNextPresentation.bind(this);
    this.handleHideShowArrows = this.handleHideShowArrows.bind(this);
  }

  handleClick() {

    const {
      handleShowPresentation,
    } = this.props;

    handleShowPresentation('');
  }

  handlePresentationToggle(goBack) {

    const {
      presentation,
      handleShowPresentation,
      allSortedDayPresentations
    } = this.props;

    if (goBack) {
      handleShowPresentation(allSortedDayPresentations[allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) - 1 ]);
    } else {
      handleShowPresentation(allSortedDayPresentations[allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) + 1]);
    }
  }

  handlePrevPresentation() {
    this.handlePresentationToggle(true);
  }
  
  handleNextPresentation() {
    this.handlePresentationToggle();
  }

  handleHideShowArrows() {
      const {
        presentation,
        allSortedDayPresentations
      } = this.props;


    if (allSortedDayPresentations) {

      if (allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) === 0) {
        this.setState({
          prevPresentationDisabled: true,
        });
      } else {
        this.setState({
          prevPresentationDisabled: false
        });
      }
    
      if (allSortedDayPresentations.findIndex(presentationItem => presentationItem.presentationId === presentation.presentationId) === allSortedDayPresentations.length - 1) {
        this.setState({
          nextPresentationDisabled: true,
        });
      } else {
        this.setState({
          nextPresentationDisabled: false
        });
      }
    }
  }

  componentDidMount() {
    this.handleHideShowArrows();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.presentation !== this.props.presentation) {
      this.handleHideShowArrows();
    }
  }



  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      presentation,
      firstHour,
      speakers,
      language,
      offsetString,
      tracksLength,
      agendaSorted,
      availableTags,
      handleIsTagActive,
      enableFilters
    } = this.props;

    const {
      dateTo,
      startHour,
      startMinutes,
      trackTitle,
      tags
    } = presentation;
    
    const {
      timezone,
    } = commonProps;

    const {
      componentPayload
    } = commonData;

    const {
      companyLogoType,
    } = componentPayload;

    const {
      nextPresentationDisabled,
      prevPresentationDisabled
    } = this.state;



    let thisPresentationDay;
    const mapAgenda = agendaSorted.map((thisAgenda) => {
      if (thisPresentationDay) return;
      if (thisAgenda && thisAgenda.tracks) thisAgenda.tracks.map((thisTracks) => {
        if (thisPresentationDay) return;
        if (thisTracks && thisTracks.presentations) thisTracks.presentations.map((thisPresentation) => {
          if (thisPresentationDay) return;
          if (thisPresentation.presentationId === presentation.presentationId) thisPresentationDay = thisAgenda;
        });
      });
    });

    if (thisPresentationDay) thisPresentationDay = thisPresentationDay && thisPresentationDay.title ? setLanguageContent(thisPresentationDay, 'title', language) : thisPresentationDay.dayDate ? moment(thisPresentationDay.dayDate).tz(timezone).format('Do MMMM') : '';



    const end = moment(dateTo).tz(timezone);

    let getHoursOffset = Number(startHour) - Number(firstHour);

    
    if (getHoursOffset >= 1) getHoursOffset = getHoursOffset + getHoursOffset;

    let minutesHeight = parseInt((100 * startMinutes) / 60);
    let calculateMinutes = parseInt((100 * startMinutes) / 60) * 2;

   if (calculateMinutes >= 100) {
      getHoursOffset = getHoursOffset + 1;
      minutesHeight = calculateMinutes - 100;
      getHoursOffset = getHoursOffset +'.'+ minutesHeight;
    } else {
      getHoursOffset = getHoursOffset +'.'+ calculateMinutes;
    }


    let thisSpeakerList = presentation && presentation.speakers ? presentation.speakers : '';

    if (thisSpeakerList) thisSpeakerList = thisSpeakerList.map((speaker) => {
      const thisSpeaker = selectSpeakerById(speakers, speaker);

      if (thisSpeaker) return thisSpeaker;      
    }).filter((a) => a);

    const speakersLength = thisSpeakerList ? thisSpeakerList.length : 0;   

    const speakerContent =  thisSpeakerList.map((thisSpeaker, i) => {     

      return (
        <RedSpeakersSpeaker
          key={'RedSpeakersSpeaker-'+thisSpeaker.speakerId}
          commonData={commonData}
          commonProps={commonProps}
          thisSpeaker={thisSpeaker}
          speakerCompany={thisSpeaker.speakerCompany}
          companyLogoType={companyLogoType}
          hideLogo={true}
          tracksLength={tracksLength}
          speakersLength={speakersLength}
          showDetails={true}
          isSingle={true}
        />
      );
    });

    const hasDescriptionContent = setLanguageContent(presentation, 'description', language);


    const descriptionContent = (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'presentationDescriptionSingle'}
        editorData={
          {
            editorType: 'presentationDescriptionSingle',
            ...commonData
          }
        }
      >
        {hasDescriptionContent}
      </Wrapper>
    );

      
    const presentationContent = (<Wrapper
      {...commonProps}
      
      typeOfStyle={'presentationContainerSingle'}
      forceStopPropagation={true}
      editorData={
        {
          editorType: 'presentationContainerSingle',
          ...commonData
        }
      }
    >

          <Wrapper
            {...commonProps}
            
            typeOfStyle={'presentationTrackTitleSingle'}
            editorData={
              {
                editorType: 'presentationTrackTitleSingle',
                ...commonData
              }
            }
          >
            {trackTitle} {thisPresentationDay && trackTitle ? ' | '+ thisPresentationDay : thisPresentationDay ? thisPresentationDay : ''}
          </Wrapper>

      {
        

          <Wrapper
            {...commonProps}
            
            typeOfStyle={'presentationTimeSingle'}
            editorData={
              {
                editorType: 'presentationTimeSingle',
                ...commonData
              }
            }
          >
            {`${startHour}:${startMinutes} - ${end.format('HH:mm')} | ${offsetString ? offsetString : ''}`}
          </Wrapper>

      }

      <Wrapper
        {...commonProps}
        
        typeOfStyle={'presentationTitleSingle'}
        editorData={
          {
            editorType: 'presentationTitleSingle',
            ...commonData
          }
        }
      >
        {setLanguageContent(presentation, 'title', language)}
      </Wrapper>


      {descriptionContent}
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'presentationSpeakerWrapperSingle'}
        editorData={
          {
            editorType: 'presentationSpeakerWrapperSingle',
            ...commonData
          }
        }
      >
        {speakerContent}
      </Wrapper>

      

        <Wrapper
          {...commonProps}
          
          typeOfStyle={'linkClose'}
          editorData={
            {
              editorType: 'linkClose',
              ...commonData
            }
          }
          handleClick={this.handleClick}
        >
        {'Close'}
      </Wrapper>
      {enableFilters && tags ? (
        <Wrapper
          {...commonProps}
          typeOfStyle={'presentationTagsWrapper'}
          editorData={
            {
              editorType: 'presentationTagsWrapper',
              ...commonData
            }
          }
        >
        {tags.map(tagId => {
          const fullTag = availableTags ? availableTags.find(tag => tag?.tagId === tagId) : '';
          return fullTag ? (
            <Wrapper
              {...commonProps}
              key={`RedAgendaPresentationTag-${fullTag.tagId}`}
              typeOfStyle={'filterTagItem'}
              editorData={
                {
                  editorType: 'filterTagItem',
                  ...commonData
                }
              }
              // onClick={() => this.handleIsTagActive(fullTag.tagId)}
            >
                {fullTag.title}
          </Wrapper>
          ) : null;
        })}
        </Wrapper>
      ) : null}
      <>
        <Wrapper
          {...commonProps}
          
          typeOfStyle={prevPresentationDisabled ? 'prevPresentationDisabled' : 'prevPresentation'}
          editorData={
            {
              editorType: prevPresentationDisabled ? 'prevPresentationDisabled' : 'prevPresentation',
              ...commonData
            }
          }
          handleClick={prevPresentationDisabled ? null : this.handlePrevPresentation}
        />
        <Wrapper
          {...commonProps}
          
          typeOfStyle={nextPresentationDisabled ? 'nextPresentationDisabled' : 'nextPresentation'}
          editorData={
            {
              editorType: nextPresentationDisabled ? 'nextPresentationDisabled' : 'nextPresentation',
              ...commonData
            }
          }
          handleClick={nextPresentationDisabled ? null: this.handleNextPresentation}
        />
      </>


    </Wrapper>)


    return (
      <Wrapper
      {...commonProps}
      
      typeOfStyle={'fullScreenWrapper'}
      handleClick={commonProps.isEditor ? null : this.handleClick}
      editorData={
        {
          editorType: 'fullScreenWrapper',
          ...commonData
        }
      }
    >
      {presentationContent}
    </Wrapper>
    );
  }
}

RedAgendaPresentation.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  presentation: PropTypes.any,
  dateTo: PropTypes.object,
  handleShowPresentation: PropTypes.func,
  speakers: PropTypes.array,
  firstHour: PropTypes.number,
  firstHourMinutes: PropTypes.number,
  blurredTop: PropTypes.bool,
  blurredBottom: PropTypes.bool,
  trackCount: PropTypes.object,
  tracksLength: PropTypes.number,
  top: PropTypes.string
};

export default RedAgendaPresentation;
